import { TrendingUp, CheckCircle2 } from "lucide-react";
import { RecommendationSummary } from "@/types/recommendation";

interface RecommendationSummaryBarProps {
  summary: RecommendationSummary;
}

export function RecommendationSummaryBar({ summary }: RecommendationSummaryBarProps) {
  return (
    <div className="rounded-2xl border bg-background/80 shadow-xl px-4 py-3 flex flex-col sm:flex-row sm:items-center justify-between gap-3">
      <div className="flex items-center gap-2.5">
        <TrendingUp className="size-4 text-primary shrink-0" />
        <span className="text-sm text-surface-foreground/60">Available</span>
        <span className="text-sm font-semibold text-foreground">
          ${summary.total_monthly_savings.toFixed(2)}/mo
        </span>
      </div>

      <div className="flex items-center gap-2.5">
        <CheckCircle2 className="size-4 text-green-500 shrink-0" />
        <span className="text-sm text-surface-foreground/60">Realized</span>
        <span className="text-sm font-semibold text-foreground">
          ${summary.realized_monthly_savings.toFixed(2)}/mo
        </span>
      </div>
    </div>
  );
}
